import React, { useEffect, useRef, useState } from "react";

import { cn } from "@/lib/utils";

type Props = {
  src: string;
  alt?: string;
  className?: string;
  style?: React.CSSProperties;
  imageClass?: string;
};

export default function LazyImage({
  src,
  alt = "",
  className,
  imageClass,
  style,
}: Props) {
  const [lowQualitySrc, setLowQualitySrc] = useState<string | null>(null);
  const [loaded, setLoaded] = useState(false);
  const highImageRef = useRef<HTMLImageElement | null>(null);

  useEffect(() => {
    const img = new Image();

    img.crossOrigin = "anonymous";
    img.src = src;

    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      const targetWidth = 50;
      const targetHeight = (img.height / img.width) * targetWidth;

      canvas.width = targetWidth;
      canvas.height = targetHeight;

      ctx?.drawImage(img, 0, 0, targetWidth, targetHeight);
      const lowSrc = canvas.toDataURL("image/jpeg", 0.1);

      setLowQualitySrc(lowSrc);
    };
  }, [src]);

  return (
    <div className={cn("relative overflow-hidden", className)} style={style}>
      {lowQualitySrc && (
        <img
          alt={alt}
          className={cn(
            "absolute top-0 left-0 w-full h-full object-cover transition-opacity duration-500 ease-in",
            loaded ? "opacity-0" : "opacity-100 blur-md scale-105",
            imageClass
          )}
          src={lowQualitySrc}
        />
      )}
      <img
        ref={highImageRef}
        alt={alt}
        className={cn(
          "w-full h-full object-cover transition-opacity duration-500",
          loaded ? "opacity-100" : "opacity-0",
          imageClass
        )}
        loading="lazy"
        src={src}
        onLoad={() => setLoaded(true)}
      />
    </div>
  );
}
